import getDestinationUrl from '@anm/helpers/stream/getDestinationUrl';
import { LiveStreamStatus, StreamingNetwork } from 'types/stream';

import { DestinationWithStreamMeta } from '../../types';

export const getDestinationParams = (state: LiveStreamStatus, destination: DestinationWithStreamMeta) => {
  if (!destination.response) return {};

  const destinationUrl = getDestinationUrl({
    network: destination.network as StreamingNetwork,
    streamStatus: state,
    response: destination.response
  });

  const hasAvatar = !!destination.avatar;

  return {
    as: hasAvatar && destination.network !== 'RTMP' ? 'a' : 'div',
    ...(hasAvatar && { href: destinationUrl, target: '_blank' })
  };
};
